<template>
  <ReportFilterSelect
    :model-value="modelValue?.toString()"
    label="Device"
    :options="deviceOptions"
    class="w-full"
    @update:model-value="
      (value) =>
        emit(
          'update:modelValue',
          value ? Number(value) : undefined
        )
    "
  />
</template>

<script setup lang="ts">
import type { Device } from "@/services/devices/listDevices"
const props = defineProps<{
  modelValue: Device["id"] | undefined
}>()

const emit = defineEmits<{
  (
    event: "update:modelValue",
    value: typeof props.modelValue
  ): void
}>()

const { data: devices } = useDevices()
const deviceOptions = computed(
  () =>
    devices.value?.map((device) => ({
      value: device.id.toString(),
      label: device.name || device.serialNumber,
    })) ?? []
)
</script>
